/* Uses Refresh's existing variant pubsub and dataLayer; no new tracker or API. */
(() => {
  if (window.smRelationsReady) return;
  window.smRelationsReady = true;
  const update = ({data}) => {
    const main = document.getElementById(`MainProduct-${data.sectionId}`);
    if (!main) return;
    const productId = main.dataset.productId;
    const available = !!data.variant?.available;
    document.querySelectorAll('[data-sm-alternatives]').forEach(list => {
      if (list.dataset.smProduct === productId) list.hidden = list.dataset.smAlternatives === 'inline' ? available : !available;
    });
    const actions = main.querySelector('[data-sm-stock-actions]');
    if (actions) {
      actions.hidden = available || !data.variant;
      const message = `Hola, me interesa ${actions.dataset.smTitle} (SKU ${data.variant?.sku || ''}) cuando vuelva a estar disponible`;
      actions.querySelector('a').href = 'https://wa.me/529988976003?text=' + encodeURIComponent(message);
    }
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, update);
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-sm-select-item]');
    if (!link || !Array.isArray(window.dataLayer)) return;
    const card = link.closest('[data-sm-item-id]');
    const list = link.closest('[data-sm-list]');
    if (!card || !list) return;
    window.dataLayer.push({event: 'select_item', ecommerce: {item_list_name: list.dataset.smList, items: [{item_id: card.dataset.smItemId, item_name: card.dataset.smItemName, item_brand: card.dataset.smItemBrand, item_variant: card.dataset.smItemVariant, price: Number(card.dataset.smItemPrice), index: [...list.querySelectorAll('[data-sm-item-id]')].indexOf(card), item_list_name: list.dataset.smList}]}});
  });
})();
